import { AppLoader } from 'shared/UI/UIKit/Loader';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppText } from 'shared/UI/UIKit/Text';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppDeleteIcon } from 'shared/UI/UIKit/icons/Delete';
import { AppEditIcon } from 'shared/UI/UIKit/icons/Edit';
import type { Month } from 'features/production-calendar/components/types';
import type { CalendarEvent } from '../model/types';
import { useCalendarListService } from '../model';
import { formatDate } from '../lib/transformCalendarDataToListData';
import styles from './styles.module.scss';

interface CalendarListProps {
  calendarYear: string;
  showCreateModal: (month: Month) => void;
  refreshTrigger: number;
  showEditModal: (month: Month, calendarEvent: CalendarEvent) => void;
  showDeleteModal: (calendarEvent: CalendarEvent) => void;
}

export const CalendarList = ({
  calendarYear,
  showCreateModal,
  refreshTrigger,
  showDeleteModal,
  showEditModal,
}: CalendarListProps) => {
  const {
    state: { listData, loading },
  } = useCalendarListService({ calendarYear, refreshTrigger });

  if (loading) {
    return <AppLoader />;
  }

  return (
    <AppFlex>
      {listData.map(({ month, dates }) => (
        <AppFlex key={month} className={styles['month-card']}>
          <AppText size={24} weight={700}>
            {month}
          </AppText>
          {dates.map((event, index) => (
            <AppFlex key={`${event.date}-${index}`} direction="row" alignItems="center">
              <AppText key={`${event.date}-${index}`} size={18}>
                {`${formatDate(event.date)} (${event.description}) - ${
                  event.holiday ? 'выходной день' : 'рабочий день'
                }`}
              </AppText>
              <AppEditIcon className={styles.icon} onClick={() => showEditModal(month, event)} />
              <AppDeleteIcon className={styles.icon} onClick={() => showDeleteModal(event)} />
            </AppFlex>
          ))}
          <AppButton
            onClick={() => showCreateModal(month)}
            key={month}
            className={styles['add-button']}
            type="outline"
          >
            Добавить дату
          </AppButton>
        </AppFlex>
      ))}
    </AppFlex>
  );
};
